'use client';

import { useMemo } from 'react';

import { defaultLocale, domainToLocaleMapping } from '@/core/constants';

function evaluateLocaleFromURL(href: string) {
  const matchedLocale = Object.keys(domainToLocaleMapping).find(
    (localeIdentifier) => href.includes(localeIdentifier),
  ) as keyof typeof domainToLocaleMapping;

  // In the event the array is empty, it implies there is no TLD and is therefore `localhost`
  if (!matchedLocale) {
    return defaultLocale;
  }

  return domainToLocaleMapping[matchedLocale];
}

export default function useLocale() {
  const href = globalThis.location?.href;

  const locale: string = useMemo(() => {
    if (typeof globalThis.location === 'undefined') {
      return defaultLocale;
    }

    return evaluateLocaleFromURL(href);
  }, [href]);

  return locale;
}
